import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import { FaDownload, FaCompress, FaBrush, FaCopy, FaCheck, FaTrash } from "react-icons/fa";
import JsonEditorPanel from "../components/JsonEditorPanel";
import CommonSeoContent from "../components/CommonSeoContent";
import useEditorActions from "../utils/useEditorActions";
import "../CodeConverter.css";

const JsonToXml = () => { 
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");

  // Import reusable actions
  const { handleDownload, handleClear } = useEditorActions(
    setInputCode,
    outputCode,
    setOutputCode
  );

  const jsonToXml = (obj, indent = '') => {
    let xml = '';

    for (let key in obj) {
      const value = obj[key];

      if (Array.isArray(value)) {
        value.forEach(item => {
          if (typeof item === 'object' && item !== null) {
            xml += `${indent}<${key}>\n${jsonToXml(item, indent + '  ')}${indent}</${key}>\n`;
          } else {
            xml += `${indent}<${key}>${item}</${key}>\n`;
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        xml += `${indent}<${key}>\n${jsonToXml(value, indent + '  ')}${indent}</${key}>\n`;
      } else {
        xml += `${indent}<${key}>${value}</${key}>\n`;
      }
    }

    return xml;
  };


  const handleConvert = () => {
    try {
      const json = JSON.parse(inputCode);
      const xml = `<root>\n${jsonToXml(json, '  ')}</root>`;
      setOutputCode(xml);
    } catch (e) {
      setOutputCode('Invalid JSON: ' + e.message);
    }
  };

  return (
  
      <div className="formatter-container">
      <h1>JSON ➝ XML Converter </h1>

      {/* Toolbar */}
      <div className="toolbar">
        <button onClick={handleConvert} className="btn primary">
          <FaBrush /> Convert
        </button>
        <button onClick={() => handleDownload("json", "formatted-json")} className="btn success">
          <FaDownload /> Download
        </button>
		<button onClick={handleClear} className="btn danger">
          <FaTrash /> Clear
        </button>
		
      </div>

      {/* Editors */}
      <div className="editor-panels">
        <JsonEditorPanel title="Input JSON" language="json" code={inputCode} setCode={setInputCode} />
        <div className="editor-section-empty-div">
        </div>
        <JsonEditorPanel title="Output XML" language="xml" code={outputCode} />
      </div>

	  <CommonSeoContent
		  title="Online JSON to XML Converter & Formatter"
		  description="Convert JSON data into Xml Document instantly with jsonconverter.org. Supports nested JSON and produces clean Go code for developers."
		  keywords="JSON to Xml, json to xml code generator, json to xml code converter, online XML converter, xml formatter, jsonconverter.org, json to xml processor"
		  author="jsonconverter.org"
		  heading="Why Use JSON to Xml Converter?"
		  whyUseText="Our JSON to XML Converter helps you quickly and accurately transform JSON data into well-structured XML documents. Whether you're integrating with legacy systems, APIs, or data feeds that require XML format, our tool saves you time by automating the conversion process. It supports complex nested JSON objects and arrays, ensuring the output XML retains the original data hierarchy and structure.Because it runs entirely in your browser, you don’t need to install anything or worry about security your data stays on your device. It’s fast, reliable, and free to use, making it perfect for developers, data analysts, and anyone working with JSON and XML."
		  howToUseSteps={[
			"Paste your JSON in the input editor.",
			"Click the Convert button",
			"View your converted XML output instantly",
			"Copy or download the XML for use in your projects.",
		  ]}
		  features={[
			"Supports nested JSON objects and arrays for accurate XML conversion",
			"Preserves data structure and types during conversion",
			"Generates clean, human-readable XML with proper indentation",
			"Runs completely in-browser — no data is sent to servers",
			"No signup or installation required — free and accessible anytime",
			"Option to download your XML output for offline use",
		  ]}
		  inputTitle="Input JSON:"
		  inputExample={`
{
  "name": "John Doe",
  "age": 30,
  "emails": ["john@example.com"],
  "isActive": true,
  "profile": {
	"bio": "Developer",
	"website": "https://jsonconverter.org"
  }
}`}
		  outputTitle="Output Xml:"
		  outputExample={`
<root>
  <name>John Doe</name>
  <age>30</age>
  <emails>john@example.com</emails>
  <isActive>true</isActive>
  <profile>
	<bio>Developer</bio>
	<website>https://jsonconverter.org</website>
  </profile>
</root>`}
		  callToAction="Start converting your JSON to Xml instantly — no signup required."
		/>  
    </div>
  );
};

export default JsonToXml;
